import { observer as globalObserver } from '../../../../../common/utils/observer';
import { translate } from '../../../../../common/i18n';
import config from '../../../../common/const';
import { setBlockTextColor, findTopParentBlock, deleteBlockIfExists } from '../../utils';
// import { defineContract } from '../images';
import { updatePurchaseChoices, fieldGeneratorMapping, dependentFieldMapping } from '../shared';
import { marketDefPlaceHolders } from './tools';
import backwardCompatibility from './backwardCompatibility';
import tradeOptions from './tradeOptions';
// import virtualTrades from './virtualTradesSetup';
import theme from '../../theme';

const bcMoveAboveInitializationsDown = block => {
    Blockly.Events.recordUndo = false;
    Blockly.Events.setGroup('BackwardCompatibility');
    const parent = block.getParent();
    if (parent) {
        const initializations = block.getInput('INITIALIZATION').connection;
        const ancestor = findTopParentBlock(parent);
        parent.nextConnection.disconnect();
        initializations.connect((ancestor || parent).previousConnection);
    }
    block.setPreviousStatement(false);
    Blockly.Events.setGroup(false);
    Blockly.Events.recordUndo = true;
};

const decorateTrade = ev => {
    const trade = Blockly.mainWorkspace.getBlockById(ev.blockId);
    if (!trade || trade.type !== 'trade') {
        return;
    }
    if ([Blockly.Events.CHANGE, Blockly.Events.MOVE, Blockly.Events.CREATE].includes(ev.type)) {
        const symbol = trade.getFieldValue('SYMBOL_LIST');
        if (symbol) {
            globalObserver.emit('bot.init', symbol);
        }

        const type = trade.getFieldValue('TRADETYPE_LIST');
        if (type) {
            const oppositesName = type.toUpperCase();
            const contractType = trade.getFieldValue('TYPE_LIST');
            if (oppositesName && contractType) {
                updatePurchaseChoices(contractType, oppositesName);
            }
        }
    }
};

const replaceInitializationBlocks = (trade, ev) => {
    if (ev.type === Blockly.Events.CREATE) {
        ev.ids.forEach(blockId => {
            const block = Blockly.mainWorkspace.getBlockById(blockId);

            if (block && block.type === 'trade' && !deleteBlockIfExists(block)) {
                bcMoveAboveInitializationsDown(block);
            }
        });
    }
};

const forceUpdateField = (trade, fieldName) => {
    Blockly.Events.fire(new Blockly.Events.Change(trade, 'field', fieldName, '', trade.getFieldValue(fieldName)));
};

const setDefaultFields = (trade, parentFieldName) => {
    if (!Object.keys(dependentFieldMapping).includes(parentFieldName)) return;
    const childFieldName = dependentFieldMapping[parentFieldName];
    const [[, defaultValue]] = fieldGeneratorMapping[childFieldName](trade)();
    trade.setFieldValue(defaultValue, childFieldName);
    if (childFieldName === 'TRADETYPECAT_LIST') forceUpdateField(trade, 'TRADETYPECAT_LIST');
};

const resetTradeFields = (trade, ev) => {
    if (ev.blockId === trade.id) {
        if (ev.element === 'field') {
            setDefaultFields(trade, ev.name);
            if (ev.name === 'TRADETYPE_LIST') {
                if (ev.newValue) {
                    trade.setFieldValue('both', 'TYPE_LIST');
                } else {
                    trade.setFieldValue('', 'TYPE_LIST');
                }
            }
        }
    }
};

Blockly.defineBlocksWithJsonArray([
    {
        'type'    : 'custom_dropdown',
        'message0': 'Choose value %1',
        'args0'   : [
            {
                'type'   : 'field_dropdown',
                'name'   : 'OPTIONS',
                'options': [
                    ['Option 1', 'OPTION1'],
                    ['Option 2', 'OPTION2'],
                    ['Option 3', 'OPTION3'],
                    ['Option 4', 'OPTION4'],
                    ['Option 5', 'OPTION5'],
                ],
            },
        ],
        'output' : 'String',
        'colour' : theme.subBlockColor,
        'tooltip': 'Custom dropdown with 5 values',
        'helpUrl': '',
    },
]);

Blockly.Blocks.trade = {
    init: function init() {
        this.appendDummyInput()
            // .appendField(new Blockly.FieldImage('', 0, 0, 'TD'))
            .appendField(new Blockly.FieldImage('', 0, 0, ''))
            .appendField(translate('Trade Definitions'), 'TITLE');
        marketDefPlaceHolders(this);
        this.appendDummyInput().appendField(`${translate('Run Once at Start')}:`);
        this.appendStatementInput('INITIALIZATION').setCheck(null);
        this.appendDummyInput().appendField(`${translate('Trade Options')}:`);
        this.appendStatementInput('SUBMARKET').setCheck(null);
        this.setColour(theme.blockColor);
        this.setTooltip(translate('Define your trade contract and start the trade, add initializations here. (Runs on start)'));
        Blockly.Blocks.trade.self = this;
    },
    onchange: function onchange(ev) {
        setBlockTextColor(this);
        if (ev.group !== 'BackwardCompatibility') {
            replaceInitializationBlocks(this, ev);
            resetTradeFields(this, ev);
        }

        if (ev.type === Blockly.Events.BLOCK_CREATE && ev.group !== 'load' && ev.ids.includes(this.id)) {
            const marketField = this.getField('MARKET_LIST');
            marketField.setValue('');
            marketField.setValue(marketField.menuGenerator_[0][1]); // eslint-disable-line
        }
        
        // eslint-disable-next-line no-underscore-dangle
        this.getField('TITLE').textElement_.removeAttribute('style');
        // this.getField('TITLE').textElement_.style.fill = '#f0b90a !important';
        if(this.collapsed_) {
            Blockly.utils.removeClass(this.getField('TITLE').textElement_, 'top-block-title');
        } else {
            Blockly.utils.addClass(this.getField('TITLE').textElement_, 'top-block-title');
        }
        

        decorateTrade(ev);
    },
};

Blockly.JavaScript.trade = block => {
    const account = $('.account-id').first().attr('value');
    if (!account) {
        throw Error('Please login');
    }
    const initialization = Blockly.JavaScript.statementToCode(block, 'INITIALIZATION');
    const tradeOptionsStatement = Blockly.JavaScript.statementToCode(block, 'SUBMARKET');
    const candleIntervalValue = block.getFieldValue('CANDLEINTERVAL_LIST');
    const contractTypeSelector = block.getFieldValue('TYPE_LIST');
    const oppositesName = block.getFieldValue('TRADETYPE_LIST').toUpperCase();
    const contractTypeList =
        contractTypeSelector === 'both'
            ? config.opposites[oppositesName].map(k => Object.keys(k)[0])
            : [contractTypeSelector];
    const timeMachineEnabled = block.getFieldValue('TIME_MACHINE_ENABLED') === 'TRUE';
    const shouldRestartOnError = block.getFieldValue('RESTARTONERROR') === 'TRUE';
    const use5000 = block.getFieldValue('USE5000') === 'TRUE';
    
    // BinaryBotPrivateVirtualSettings = {
    //     token: '${block.getFieldValue('VIRTUAL_TOKEN')}',
    //     ongoing: true,
    //     valid: true,
    //     changeToVirtual: false,
    //     changeToReal: false,
    //     steps: 0,
    //     realSteps:0, 
    //     minTradesOnReal: ${block.getFieldValue('VIRTUAL_MINSTEPS')},
    //     maxTradesOnReal: ${block.getFieldValue('VIRTUAL_MAXSTEPS')},
    //     goBack: '${block.getFieldValue('VIRTUAL_GOBACK')}',
    //     active: ${block.getFieldValue('VIRTUAL_ACTIVE') === 'enabled'},
    //     maxSteps: ${block.getFieldValue('VIRTUAL_STEPS')},
    //     reset: ${block.getFieldValue('VIRTUAL_RESET') === 'enabled'}
    // }
    const code = `
${initialization.trim()}
BinaryBotPrivateInit = function BinaryBotPrivateInit() {
    Bot.init('${account}', {
        symbol: '${block.getFieldValue('SYMBOL_LIST')}',
        contractTypes: ${JSON.stringify(contractTypeList)},
        candleInterval: '${candleIntervalValue}',
        shouldRestartOnError: ${shouldRestartOnError},
        timeMachineEnabled: ${timeMachineEnabled},
        virtualTrades: BinaryBotPrivateVirtualSettings,
        use5000: ${use5000}
    });

};

BinaryBotPrivateStart = function BinaryBotPrivateStart() {
    ${tradeOptionsStatement.trim()}
};`;
    return code;
};


export default () => {
    backwardCompatibility();
    tradeOptions();
};




// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/trade/index.js